import { render, staticRenderFns } from "./milling-revenue.card.vue?vue&type=template&id=3b300e50&"
import script from "./milling-revenue.card.vue?vue&type=script&lang=js&"
export * from "./milling-revenue.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports